// BE data interfaces
export interface GNEventLog {
    eventTimestamp: number,
    eventLocation: string,
    eventAction: string,
    eventLabel: string,
    eventLog: string,
    eventStackTrace: string,
    eventLatestInstanceLog: string,
    eventDownloadURL: string,
    sessionID: string,
    clientType: 'client' | 'server' | 'editor' | string,
    projectID: string,
    userID: string,
    userName: string,
    pluginVersion: string,
    projectVersion: string,
    buildID: string,
    baseMemoryAddress: string,
    platformOS: string,
    platformCPU: string,
    platformGPU: string,
    platformRAM: string
}
  
  export interface GNAnalyticsUserData {
    projectID: string,
    userID: string,
    clientType: 'client' | 'server' | 'editor' | string,
    userName: string,
    country: string,
    platformOS: string,
    platformCPU: string,
    platformGPU: string,
    platformRAM: string,
    latestSessionTimestamp: number
    events: GNEventLog[],
  }
  
  /**
   * Defines Analyticd User State interface
   */
  export interface AnalyticsUserState {
      // http state
      httpInProgress: boolean;
      httpError: string;
      // BE data
      userData: GNAnalyticsUserData;
    }
    
    /**
     * Defines Analytics Project actions names
     */
    export const ANALYTICS_USER_IN_PROGRESS = 'ANALYTICS_USER_IN_PROGRESS'
    export const ANALYTICS_USER_ERROR = 'ANALYTICS_USER_ERROR'
    export const ANALYTICS_USER_GET = 'ANALYTICS_USER_GET'
    
    /**
     * Defines Analytics User actions interfaces
     */
    interface AnalyticsUserInProgressAction {
      type: typeof ANALYTICS_USER_IN_PROGRESS;
    }
    interface AnalyticsUserErrorAction {
      type: typeof ANALYTICS_USER_ERROR;
      error: string;
    }
    interface AnalyticsUserGetAction {
      type: typeof ANALYTICS_USER_GET;
      userData: GNAnalyticsUserData;
    }

    
    /**
     * Defines all suported actions for Analytics User
     */
    export type AnalyticsUserActionTypes =
      AnalyticsUserInProgressAction |
      AnalyticsUserErrorAction |
      AnalyticsUserGetAction;
    
    /**
     * Defines AnalyticsUserActionsInterface
     */
    export interface AnalyticsUserActionsInterface {
      analyticsUserGet: ( userDataID: string, projectID: string ) => Promise<void>;
    }
    